module.exports = __webpack_public_path__ + "img/9788976827555.b06ee7ed.jpg";